module.exports = __webpack_public_path__ + "static/sport/left-txt.c1bebf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/left-txt.png
// module id = VRTU
// module chunks = 0